import React from "react";
import { Swiper, SwiperSlide } from "components/swiper";
import { ReactComponent as RightArrow } from "assets/svgs/right-arrow.svg";
import { ReactComponent as LeftArrow } from "assets/svgs/left-arrow.svg";
import Image from "components/image";
import { formatTitle } from "helpers/format-title";

const settings = {
	// loop: true,
	simulateTouch: false,
	mousewheel: {
		enabled: true,
		forceToAxis: true,
	},
	navigation: {
		enabled: true,
		nextEl: ".right-arrow-t",
		prevEl: ".left-arrow-t",
		disabledClass: "opacity-30 pointer-events-none cursor-auto"
	},
	a11y: true,
};

const Testimonials = ({ data: testimonials }) => (
	<div className="w-full m-auto md:w-11/12 md:mt-20">
		<h2 className="text-center mb-10">{formatTitle(testimonials.title)}</h2>
		<p className="text-center text-[6.125em] font-[Baskerville]">&quot;</p>
		<Swiper className="m-auto mb-10" {...settings}>
			{testimonials.data.map((t) => (
				<SwiperSlide className="w-1/2 m-auto" key={t._key}>
					<div className="w-4/5 m-auto md:w-3/4">
						<div className="italic text-body text-center">{t.text} </div>
						<div className="text-center mt-10">
							<Image width={120} image={t.logo} alt={t.logo?.alt} />
						</div>
					</div>
				</SwiperSlide>
			))}
			<div className="left-arrow-t">
				<LeftArrow role="presentation" aria-hidden="true" />
			</div>
			<div className="right-arrow-t">
				<RightArrow role="presentation" aria-hidden="true" />
			</div>
		</Swiper>
	</div>
);

export default Testimonials;